"use client"

import { Button, type ButtonProps } from "@mui/material"
import type { FC, ReactNode } from "react"
import { useDevMode } from "app/contexts/DevModeContext"

interface DevButtonProps extends Omit<ButtonProps, "variant"> {
  children: ReactNode
  /** アイコンを非表示にする */
  hideIcon?: boolean
}

/**
 * 開発専用のボタンコンポーネント
 * - オレンジ系のスタイルで「開発専用」とわかるデザイン
 * - NODE_ENV === "development" かつ isDevUIVisible === true の場合のみ表示
 * - 本番環境では何も表示しない
 *
 * @example
 * <DevButton onClick={handleCopyJson}>Copy as JSON</DevButton>
 */
export const DevButton: FC<DevButtonProps> = ({
  children,
  hideIcon = false,
  sx,
  ...props
}) => {
  const { isDevMode } = useDevMode()

  if (!isDevMode) {
    return null
  }

  return (
    <Button
      variant="outlined"
      size="small"
      {...props}
      sx={{
        borderColor: "warning.main",
        color: "warning.dark",
        backgroundColor: "rgba(255, 152, 0, 0.04)",
        fontSize: "0.75rem",
        "&:hover": {
          borderColor: "warning.dark",
          backgroundColor: "rgba(255, 152, 0, 0.12)",
        },
        ...sx,
      }}
    >
      {!hideIcon && "🛠 "}
      {children}
    </Button>
  )
}
